import Text from 'components/atoms/Text';
import { Col, Container, renderBreakPoints, Row } from 'components/atoms/Grid';
import Colors from 'components/tokens/Colors';
import styled, { css } from 'styled-components';
import Link from 'components/atoms/Link';
import { spacing } from 'components/atoms/Grid/constants';
import { sbEditable } from '@storyblok/storyblok-editable';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/client';
import { render } from 'storyblok-rich-text-react-renderer';
import { getAssetURL } from 'helpers/getAssetURL';
import placeholder from 'assets/image_placeholder.png';

const colors = [
    Colors.educationYellow,
    Colors.educationGreen,
    Colors.educationBlue,
    Colors.educationOrange,
    Colors.primary
];

const query = gql`
    query ($uuids: String) {
        ProjectItems(by_uuids: $uuids) {
            items {
                uuid
                full_slug
                name
                first_published_at
                content {
                    resume
                    label_color
                    featured_image {
                        filename
                        alt
                    }
                }
            }
        }
    }
`;

const MainContent = styled.div`
    background: ${Colors.lightGrey};
`;

const ContentContainer = styled.div`
    ${props => {
        let pb = props.pb ? props.pb.split(' ') : ['0'];
        let pt = props.pt ? props.pt.split(' ') : ['0'];
        let pl = props.pl ? props.pl.split(' ') : ['0'];
        let pr = props.pr ? props.pr.split(' ') : ['0'];

        return renderBreakPoints(
            k => css`
                ${pt[k] &&
                css`
                    padding-top: ${parseFloat(pt[k]) * spacing}px;
                `}
                ${pb[k] &&
                css`
                    padding-bottom: ${parseFloat(pb[k]) * spacing}px;
                `}
                ${pl[k] &&
                css`
                    padding-left: ${parseFloat(pl[k]) * spacing}px;
                `}
                ${pr[k] &&
                css`
                    padding-right: ${parseFloat(pr[k]) * spacing}px;
                `}
            `
        );
    }}
    background-color: ${Colors.white};
`;

const ColoredCol = styled(Col)`
    background-color: ${({ bgColor }) => (bgColor.toString() ? colors[bgColor] : Colors.primary)};
`;

const ImageCard = styled.div`
    width: 100%;
    padding-top: 70%;
    display: flex;
    background-color: #333;
    position: relative;
    background-position: center;
    ${props =>
        props.bg &&
        css`
            background-image: url('${props.bg}');
            background-size: cover;
        `}
`;

const StyledCol = styled(Col)`
    transition: transform 200ms;
    &:hover {
        transform: scale(1.02);
        cursor: pointer;
    }
`;

export default function ProjectsCards(props) {
    let uuidsProjects = [];
    props?.projects?.map(item => uuidsProjects.push(item));

    const result = useQuery(query, { variables: { uuids: uuidsProjects.toString() } });
    const projects = result.data?.ProjectItems?.items || [];

    return (
        <MainContent {...sbEditable(props)}>
            <Container px="1.5 4">
                <Row mt="8 12" mb="3 7">
                    {projects &&
                        projects.map(card => {
                            return (
                                <StyledCol size="12 4" key={card.uuid}>
                                    <Link decoration="none" weight="normal" href={card?.full_slug}>
                                        <Row>
                                            <Col size="12">
                                                <ImageCard
                                                    bg={
                                                        getAssetURL(card?.content?.featured_image?.filename) ||
                                                        placeholder
                                                    }
                                                />
                                            </Col>
                                            <Col size="12">
                                                <ContentContainer pb="3" pt="3" pl="3" pr="3">
                                                    <Text body1 highlight>
                                                        {card?.name}
                                                    </Text>
                                                </ContentContainer>
                                            </Col>
                                            <Col size="12">
                                                <ContentContainer pb="5" pl="3" pr="3">
                                                    <StyledText body2>{render(card?.content?.resume)}</StyledText>
                                                </ContentContainer>
                                            </Col>
                                            <Col size="12" mb="5">
                                                <ColoredCol bgColor={card?.content?.label_color} size="12" pt="1 2" />
                                            </Col>
                                        </Row>
                                    </Link>
                                </StyledCol>
                            );
                        })}
                </Row>
            </Container>
        </MainContent>
    );
}

const StyledText = styled(Text)`
    a {
        color: black;
        text-decoration: none;
    }

    a:hover {
        color: black;
        text-decoration: none;
    }
`;
